import React from 'react';
import { stats as fallbackStats } from '../data/mock';
import { useContent } from '../hooks/useContent';

export default function StatsCard() {
  const stats = useContent('stats', fallbackStats) || fallbackStats;
  return (
    <div className="relative z-20 -mt-24 mb-4">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 py-10 md:py-12 px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((s, i) => (
              <div key={i} className="text-center">
                <div className="font-serif text-4xl md:text-5xl font-bold text-primary mb-2">
                  {s.value.replace(/[+%]/g, '')}
                  <span className="text-brand">{s.value.match(/[+%]/g)?.join('') || ''}</span>
                </div>
                <div className="text-xs md:text-sm font-medium text-muted-foreground uppercase tracking-wider">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
